<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="operationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settlementTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioCetipAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Cetip</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioCetipAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isSecondaryMarket">
    <th mat-header-cell class="header" *matHeaderCellDef>Mercado Secundário</th>
    <td mat-cell *matCellDef="let element">
      {{ element.isSecondaryMarket ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isIssueUnitPrice">
    <th mat-header-cell class="header" *matHeaderCellDef>É PU de Emissão?</th>
    <td mat-cell *matCellDef="let element">
      {{ element.isIssueUnitPrice ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationValue">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor da Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationValue | currency: "R$":"symbol":"1.2-2" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th mat-header-cell class="header" *matHeaderCellDef>Quantidade</th>
    <td mat-cell *matCellDef="let element">
      {{ element.amount | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="quotaValue">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor da Cota</th>
    <td mat-cell *matCellDef="let element">
      {{ element.quotaValue | currency: "R$":"symbol":"1.8-8" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="subscriptionDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data de subscrição</th>
    <td mat-cell *matCellDef="let element">
      {{ element.subscriptionDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isNewFund">
    <th mat-header-cell class="header" *matHeaderCellDef>
      É novo fundo no mercado?
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isNewFund ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>
      CNPJ do Fundo Investido
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundName">
    <th mat-header-cell class="header" *matHeaderCellDef>Fundo Investido</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundAdministrator">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Administrador Fundo Investido
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundAdministrator }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="mnemonicCode">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Código do Ativo / IF
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.mnemonicCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="quotationDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Cotização</th>
    <td mat-cell *matCellDef="let element">
      {{ element.quotationDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settlementDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundType">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Tipo de Cota do Condomínio
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundClass">
    <th mat-header-cell class="header" *matHeaderCellDef>Classe</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundClass }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundSeries">
    <th mat-header-cell class="header" *matHeaderCellDef>Série</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundSeries }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fundSeriesQuantity">
    <th mat-header-cell class="header" *matHeaderCellDef>Quantidade Série</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundSeriesQuantity }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isNewCounterpart">
    <th mat-header-cell class="header" *matHeaderCellDef>
      É nova Contraparte?
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isNewCounterpart ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions" sticky>
    <th mat-header-cell class="header" *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" class="actions"></td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="ColumnsQuota.length">
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsQuota"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsQuota"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
